<template>
  <div v-if="layer">
    <h5>
      <router-link class="" :to="{ name: 'Layers' }">
        {{ $t("Layers.title") }}
      </router-link>
      <span class='text-muted'>&raquo;</span>
    </h5>
    <h1>{{ layer.name }}</h1>
    <ul>
      <li v-for="feature in layer.features" :key="feature.id">
        <router-link :to="{
          name: 'Feature',
          params: { uuid: feature.id }
        }">
          {{ feature.name }}
        </router-link>
      </li>
    </ul>
    <nav v-if="totalPages > 1">
      <paginate
        :pageCount="totalPages"
        :containerClass="'pagination'"
        :pageClass="'page-item'"
        :pageLinkClass="'page-link'"
        :prevText="'&laquo;'"
        :prevClass="'page-item'"
        :prevLinkClass="'page-link'"
        :nextText="'&raquo;'"
        :nextClass="'page-item'"
        :nextLinkClass="'page-link'"
        :clickHandler="changePage">
      </paginate>
    </nav>
  </div>
</template>

<script>
import gql from "graphql-tag";

const PAGE_SIZE = 20;

export default {
  props: {
    uuid: String
  },
  data() {
    return {
      layer: null,
      currentPage: 1
    };
  },
  computed:{
    totalPages() {
      try {
        return Math.ceil(this.layer.features_aggregate.aggregate.count / PAGE_SIZE)
      }
      catch(_err) {
        return 0
      }
    },
    currentOffset() {
      return (this.currentPage - 1) * PAGE_SIZE;
    }
  },
  methods: {
    changePage(pageNum) {
      this.currentPage = pageNum;
    }
  },
  apollo: {
    layer: {
      query: gql`query fetchLayer($id: uuid!, $limit: Int, $offset: Int){
        layer: layers_by_pk(id: $id){
          id
          name
          mapbox_identifier
          features_aggregate {
            aggregate {
              count
            }
          }
          features(order_by: {name: asc}, limit: $limit, offset: $offset) {
            id
            name
          }
        }
      }`,
      variables(){
        return {
          id: this.uuid,
          limit: PAGE_SIZE,
          offset: this.currentOffset
        }
      }
    }
  },
  updated() {
    this.$store.dispatch("showLayerUrl", this.layer.mapbox_identifier);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Layer.vue